import Modal from './modal';

export * from './modal';
export * from './modal-close-button';
export * from './modal-wrapper';

export default Modal;
